module.exports = __webpack_public_path__ + "static/media/generic.e948b723.png";